import React from 'react';
import { Label } from "reactstrap";

export default function Card({ className, title, status, children }) {
     return (
        <div className={ className ? "card " + className : "card"}>
            { title
                && <h2>{ title }
                        {status &&
                            <Label className="situacao-btn em-espera">{ status }</Label>
                        }
                    </h2>
            }
            { children }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/Card.js